import React from "react";
import { Radio, Space } from "antd";
import { ENGINE_OPTIONS, isEngineChoiceShown } from "../utils/engine";

/**
 * The engine choice shown inside a pause or empty confirmation. Renders nothing outside dev, where every command
 * goes to the legacy trade server.
 */
const EngineChoice = ({ engine, onChange }) => {
  if (!isEngineChoiceShown()) {
    return null;
  }
  return (
    <Space>
      Engine:
      <Radio.Group value={engine} onChange={(event) => onChange(event.target.value)} options={ENGINE_OPTIONS} />
    </Space>
  );
};

export default EngineChoice;
